import {
  Heart,
  Stethoscope,
  Pill,
  Syringe,
  FlaskRound,
  Thermometer,
  Brain,
  Activity,
  Microscope,
  Ambulance,
} from "lucide-react";

export const MEDICAL_ICONS = [
  { icon: Heart, name: "Heart" },
  { icon: Stethoscope, name: "Stethoscope" },
  { icon: Pill, name: "Pill" },
  { icon: Syringe, name: "Syringe" },
  { icon: FlaskRound, name: "Flask" },
  { icon: Thermometer, name: "Thermometer" },
  { icon: Brain, name: "Brain" },
  { icon: Activity, name: "Activity" },
  { icon: Microscope, name: "Microscope" },
  { icon: Ambulance, name: "FirstAid" },
];
